module.exports = __webpack_public_path__ + "img/containerBg.832dd8d5.png";